import { combineReducers } from 'redux';
import socketReducer from './socketReducer';
import finalStateReducer from './finalStateReducer';
import UserInfoReducer from './UserInfo';

export default combineReducers({
    items: socketReducer,
  finalState: finalStateReducer,
  userInfo: UserInfoReducer, 
});

